declare const __APP_BASE_NAME__: string | undefined;
declare const __APP_SERVER_NAME__: string | undefined;
declare const __APP_DISPLAY_NAME_OVERRIDE__: string | null | undefined;
declare const __APP_LOGO_DATA_URL__: string | null | undefined;

const DEFAULT_APP_BASE_NAME = "T3 Code";
const DEFAULT_APP_SERVER_NAME = `${DEFAULT_APP_BASE_NAME} Server`;

const hostedAppChannel = import.meta.env.VITE_HOSTED_APP_CHANNEL?.trim().toLowerCase();

function readBuildTimeBaseName(): string {
  return typeof __APP_BASE_NAME__ === "string" ? __APP_BASE_NAME__ : DEFAULT_APP_BASE_NAME;
}

function readBuildTimeServerName(): string {
  return typeof __APP_SERVER_NAME__ === "string" ? __APP_SERVER_NAME__ : DEFAULT_APP_SERVER_NAME;
}

function readBuildTimeDisplayNameOverride(): string | null {
  return typeof __APP_DISPLAY_NAME_OVERRIDE__ === "string" ? __APP_DISPLAY_NAME_OVERRIDE__ : null;
}

function readBuildTimeLogoDataUrl(): string | null {
  return typeof __APP_LOGO_DATA_URL__ === "string" ? __APP_LOGO_DATA_URL__ : null;
}

export const HOSTED_APP_CHANNEL =
  hostedAppChannel === "latest" || hostedAppChannel === "nightly" ? hostedAppChannel : null;
export const HOSTED_APP_CHANNEL_LABEL =
  HOSTED_APP_CHANNEL === "nightly" ? "Nightly" : HOSTED_APP_CHANNEL === "latest" ? "Latest" : null;
export const APP_BASE_NAME = readBuildTimeBaseName();
export const APP_SERVER_NAME = readBuildTimeServerName();
export const APP_STAGE_LABEL = HOSTED_APP_CHANNEL_LABEL ?? (import.meta.env.DEV ? "Dev" : "Alpha");
export const APP_DISPLAY_NAME =
  readBuildTimeDisplayNameOverride() ?? `${APP_BASE_NAME} (${APP_STAGE_LABEL})`;
export const APP_LOGO_DATA_URL = readBuildTimeLogoDataUrl();
export const APP_VERSION = import.meta.env.APP_VERSION || "0.0.0";
